<template>
	<section class='knd-articles knd-constraint'>
			<Article 
				v-for='(article,index) in articles' 
				:key='"article-" + index' 
				:article="article"
				:class="'id-' + article.id"
				:open="article.id == routeArticleId"
			/>
	</section>
</template>

<script>

	import Article from './article';
	
	const vueObject = {
		components: {Article},
		data: function() {
			return {
				routeArticleId: null
			}
		},
		
		computed: {
			articles() { 
				return this.$store.state.filteredData;
			}
		},
		
		mounted: function() {
			// scrollto active element and open up article
			if (this.$route.query.article) {
				let el = document.querySelector('.id-' + this.$route.query.article);
				if (!el) return;

				el.scrollIntoView();
				this.routeArticleId = this.$route.query.article;
			}
		},
		methods: {}
	}

	export default vueObject;
</script>